  <div class="appointments-list-empty">
    <div class="appointments-list-empty__header">
      <% if (schedulingOptions.icon) { %><sp-icon class="appointments-list-empty__icon" name="<%= schedulingOptions.icon %>"></sp-icon><% } %>
      <% if (schedulingOptions.message) { %><div class="appointments-list-empty__message"><%= schedulingOptions.message %></div><% } %>
    </div>
    <% if (schedulingOptions.url) { %><sp-button tag="a" size="small" href="<%= schedulingOptions.url %>" target="_blank"><%= schedulingOptions.label %></sp-button><% } %>
    <% if (schedulingOptions.booking_number_message) { %><div class="appointments-list-empty__booking-number-message"><%= schedulingOptions.booking_number_message %></div><% } %>
  </div>
